import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    shippingAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipcode: '',
    },
    billingAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        zipcode: '',
    },
    billingInfo: {
        paymentMethodId: '',
        last4Number: '',
        expirationMonth: '',
        expirationYear: '',
        stored: false,
    },
    guestContact: {
        firstname: '',
        lastname: '',
        email: '',
    },
    items: [],
    salesTax: 0,
    subtotal: 0,
};

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        updateBillingAddress(state, action) {
            state.billingAddress = action.payload;
        },
        updateBillingInfo(state, action) {
            const incoming = typeof action.payload === 'function'
                ? action.payload(state.billingInfo)
                : action.payload;

            state.billingInfo = {...incoming};
        },
        finishCheckout(state) {
            state.shippingAddress = initialState.shippingAddress;
            state.billingAddress = initialState.billingAddress;
            state.billingInfo = initialState.billingInfo;
            state.guestContact = initialState.guestContact;
            state.items = initialState.items;
            state.salesTax = initialState.salesTax;
            state.subtotal = initialState.subtotal;
        },
        setGuestData(state, action) {
            state.guestData = action.payload;
        },

        setShippingInfo(state, action) {
            state.shippingAddress = action.payload;
        },

    },
});

export const {
    updateBillingAddress,
    updateBillingInfo,
    finishCheckout,
    setShippingInfo,
    setGuestData,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;

